import React from 'react';
import headerActions from '../../../../actions/header';
import translate from '../../../../utils/translate';

export default class TopLinksAccount extends React.Component {
  static propTypes = {
    isActive: React.PropTypes.bool,
    panels:   React.PropTypes.object,
    loggedUser: React.PropTypes.object
  };

  state = {
    tabWidth: false
  };

  toggleAccountPanel = () => {
    var currentWidth = this.refs['accountBtn'].getBoundingClientRect().width;

    this.setState({
      tabWidth: this.props.isActive ? 'auto' : currentWidth
    });

    headerActions.toggleTopPanel('account');
  };

  render () {
    var buttonText = (this.props.panels.top === 'account' ? '' : translate('headerModule', 'YOUR_ACCOUNT'));

    if (this.props.loggedUser) {
      buttonText = translate('headerModule', 'MY_ACCOUNT_WELCOME_BACK');
    }

    var style = { width: this.state.tabWidth };

    // TODO, refactor, its soo similar to btnlanguage
    var btnClassName = 'toplinks__button--account';
    btnClassName += this.props.panels.top === 'account' ? ' is-active' : '';

    if (this.props.panels.top === 'account') {
      buttonText = '';
    }

    return (
      <div className="toplinks__primary__item">
        <button
          ref="accountBtn"
          className={btnClassName}
          onClick={this.toggleAccountPanel}
          style={style}
          data-component="account">
          {buttonText}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/toplinks/btnaccount/index.js